'use strict';

var FeatureToggleConfig = function FeatureToggleConfig(featureToggleService, bootstrapFeaturesService) {
  var features = bootstrapFeaturesService.getFeaturesWithAppPriorityApplied();
  featureToggleService.initialize(features);
};
FeatureToggleConfig.$inject = ['FeatureToggleService', 'BootstrapFeaturesService'];
module.exports = FeatureToggleConfig;